import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { CheckVisionModelRateResult } from './CheckVisionModelRateResult'

@InputType()
export class CheckVisionModelRateArgs extends ActionArgs {
  /**
   * Model to check instead of `openAiConfig.visionModel`. Omitted → the Model Rates admin
   * page's original behavior, byte-identical. Passed explicitly by QuickScore's
   * `ResolveScanRoute` to pre-flight the model a scan is about to be routed to,
   * reusing this action's existing `ModelRate` lookup rather than adding a second one.
   */
  @Field(() => String, { nullable: true })
  model?: string
}

export interface ICheckVisionModelRate extends IAction<CheckVisionModelRateResult, CheckVisionModelRateArgs> {}
